import { Route, Routes } from 'react-router-dom';

import Landing from 'src/views/Landing';
import ErrorPage from 'src/views/ErrorPage';
import PrivacyPolicy from 'src/views/PrivacyPolicy';
import Eula from 'src/views/Eula';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Landing />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/eula' element={<Eula />} />
      <Route path='*' element={<ErrorPage />} />
    </Routes>
  );
};

export default AppRoutes;
